import { useContext, useState } from "react";
import { Nav, NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";
import HourglassGlobals, { HGContext } from "../../helpers/globals";
import { Permission } from "../../types/permission";
import { ExportModalLazy } from "../congregation/async";
import { hasPermission } from "../../helpers/hasPermission";
import { UserStatus } from "../../types/user";

const ROUTES = {
  MANAGE_GROUPS: "/manageGroups",
  MANAGE_LANG_GROUPS: "/manageLangGroups",
  ATTENDANCE: "/attendance",
  TERRITORY: "/congregation/territory",
  CONG_PROFILE: "/congProfile",
  NOTIFICATIONS: "/congNotifications",
  ACTIVITY: "/activity",
  IMPORT: "/import",
  E2E_MIGRATION: "/e2eMigration",
  SETTINGS: "/settings",
  CIRCUIT: "/circuit",
} as const;

export function NavCongregation() {
  const { t } = useTranslation();
  const location = useLocation();
  const ctx = useContext(HGContext);
  const [showExportModal, setShowExportModal] = useState(false);

  const isCO = HourglassGlobals.authUser.status === UserStatus.CO;
  const isActive = (path: string) => (location.pathname === path ? "bg-primary text-white" : "");

  const showActivity = HourglassGlobals.isAdmin();

  const showImport =
    hasPermission(Permission.UpdateUsers) &&
    hasPermission(Permission.UpdateReports) &&
    hasPermission(Permission.UpdateAttendance);
  const canManagePermissions = hasPermission(Permission.ManagePermissions);
  const showProfile = hasPermission(Permission.UpdateCongregation) || canManagePermissions;
  const showExportMenu =
    hasPermission(Permission.ViewUsers) &&
    hasPermission(Permission.ViewReportsAll) &&
    hasPermission(Permission.ViewAddresses) &&
    hasPermission(Permission.ViewEmergencycontacts);
  const showAttendance = hasPermission(Permission.ViewSummary) || hasPermission(Permission.UpdateAttendance);
  const showTerritory = hasPermission(Permission.ViewSchedules) || hasPermission(Permission.UpdateTerritory);

  return (
    <Nav className="flex-column hg-nav">
      {showExportModal && <ExportModalLazy show={showExportModal} setShow={setShowExportModal} />}

      <NavDropdown.Item as={Link} to={ROUTES.MANAGE_GROUPS} className={isActive(ROUTES.MANAGE_GROUPS)}>
        {t("nav.congregation.fsgroups")}
      </NavDropdown.Item>
      <NavDropdown.Item as={Link} to={ROUTES.MANAGE_LANG_GROUPS} className={isActive(ROUTES.MANAGE_LANG_GROUPS)}>
        {t("schedules.language-groups.title")}
      </NavDropdown.Item>

      {showAttendance && (
        <NavDropdown.Item as={Link} to={ROUTES.ATTENDANCE} className={isActive(ROUTES.ATTENDANCE)}>
          {t("nav.congregation.attendance")}
        </NavDropdown.Item>
      )}

      {showTerritory && (
        <NavDropdown.Item as={Link} to={ROUTES.TERRITORY} className={isActive(ROUTES.TERRITORY)}>
          {t("schedules.territory.territory")}
        </NavDropdown.Item>
      )}

      {(showProfile || showImport || showExportMenu) && <NavDropdown.Divider />}

      {showProfile && (
        <NavDropdown.Item as={Link} to={ROUTES.CONG_PROFILE} className={isActive(ROUTES.CONG_PROFILE)}>
          {t("nav.congregation.profile-permissions")}
        </NavDropdown.Item>
      )}

      {canManagePermissions && (
        <NavDropdown.Item as={Link} to={ROUTES.NOTIFICATIONS} className={isActive(ROUTES.NOTIFICATIONS)}>
          {t("general.notifications")}
        </NavDropdown.Item>
      )}

      {showActivity && (
        <NavDropdown.Item as={Link} to={ROUTES.ACTIVITY} className={isActive(ROUTES.ACTIVITY)}>
          {t("nav.activity")}
        </NavDropdown.Item>
      )}

      {showImport && (
        <NavDropdown.Item as={Link} to={ROUTES.IMPORT} className={isActive(ROUTES.IMPORT)}>
          {t("nav.congregation.import")}
        </NavDropdown.Item>
      )}

      {showExportMenu && (
        <NavDropdown.Item onClick={() => setShowExportModal(true)}>{t("nav.congregation.export")}</NavDropdown.Item>
      )}

      {HourglassGlobals.isAdmin() && !!ctx.globals.e2eKey && (
        <>
          <NavDropdown.Divider />
          <NavDropdown.Item as={Link} to={ROUTES.E2E_MIGRATION} className={isActive(ROUTES.E2E_MIGRATION)}>
            {t("nav.e2e")}
          </NavDropdown.Item>
        </>
      )}

      {HourglassGlobals.isAdmin() && (
        <NavDropdown.Item as={Link} to={ROUTES.SETTINGS} className={isActive(ROUTES.SETTINGS)}>
          {t("Jcy-FH-fbr.title")}
        </NavDropdown.Item>
      )}

      {isCO && (
        <>
          <NavDropdown.Divider />
          <NavDropdown.Item as={Link} to={ROUTES.CIRCUIT} className={isActive(ROUTES.CIRCUIT)}>
            {t("circuit.circuit")}
          </NavDropdown.Item>
        </>
      )}
    </Nav>
  );
}
